import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { faInfoCircle } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Button, Icon, TextField } from '@seeqdev/qomponents';

interface IrregularScheduleProps {
  schedules: string[];
  onConvertIt: () => void;
  disabled?: boolean;
}

export const IrregularSchedule = ({ schedules, onConvertIt, disabled = false }: IrregularScheduleProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="live-schedule-config" {...stylex.props(styles.irregularSchedule)}>
      <label>{t('SCHEDULE_TYPE.IRREGULAR_SCHEDULE')}</label>
      {_.map(schedules, (schedule) => (
        <TextField
          key={schedule}
          disabled={true}
          xstyle={styles.cronField}
          testId="irregular-schedule-config__cron-schedule"
          type="text"
          value={schedule}
        />
      ))}

      <div className={clsx('flexColumnContainer', stylex.props(styles.conversionHelp).className)}>
        <Icon icon={faInfoCircle} large={true} xstyle={styles.helpIcon} />
        <span>{t('SCHEDULE_TYPE.IRREGULAR')}</span>
        <Button
          testId="irregular-schedule-config__convert-it"
          xstyle={styles.convertButton}
          label={t('SCHEDULE_TYPE.IRREGULAR_CONVERT_IT')}
          onClick={onConvertIt}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

const styles = stylex.create({
  cronField: { marginBottom: 15 },
  convertButton: { width: 250 },
  helpIcon: { padding: '.25rem', cursor: 'pointer', borderRadius: '.25rem' },
  irregularSchedule: {
    marginBottom: '0.9375rem',
  },
  conversionHelp: {
    alignItems: 'flex-start',
  },
});
